import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiDataAdapterConfig } from './types/api-data-adapter-config.type';

export const API_DATA_ADAPTER_CONFIG = new InjectionToken<Observable<ApiDataAdapterConfig>>('Api Data Adapter Config');
